import { render, staticRenderFns } from "./FoodCourtExtraDetails.vue?vue&type=template&id=4b552896&scoped=true"
import script from "./FoodCourtExtraDetails.vue?vue&type=script&lang=js"
export * from "./FoodCourtExtraDetails.vue?vue&type=script&lang=js"
import style0 from "./FoodCourtExtraDetails.vue?vue&type=style&index=0&id=4b552896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b552896",
  null
  
)

export default component.exports